import { trans } from '@spotahome/soyuz/client';

import LandingSellingPointsSection from '@spotahome/ui-library/src/tenant/components/LandingSellingPointsSection';

import MedalVerifiedIcon from './Icons/MedalVerifiedIcon';
import WalletCoinIcon from './Icons/WalletCoinIcon';
import KnittedIcon from './Icons/KnittedIcon';

const POINTS = [
  {
    titleKey: 'seo.countries.selling.points.block1.title',
    textKey: 'seo.countries.selling.points.block1.text',
    renderImage: className => <MedalVerifiedIcon className={className} />
  },
  {
    titleKey: 'seo.countries.selling.points.block2.title',
    textKey: 'seo.countries.selling.points.block2.text',
    renderImage: className => <WalletCoinIcon className={className} />
  },
  {
    titleKey: 'seo.countries.selling.points.block3.title',
    textKey: 'seo.countries.selling.points.block3.text',
    renderImage: className => <KnittedIcon className={className} />
  }
];

const SellingPoints = () => {
  return (
    <LandingSellingPointsSection
      title={trans('seo.countries.selling.points.title')}
      description={trans('seo.countries.selling.points.description')}
      points={POINTS}
      color="white"
    />
  );
};

export default SellingPoints;
